/**
 * Botón con los cuatro estados que una acción de verdad tiene.
 *
 * `cargando` deshabilita el botón. Sin eso, un doble clic en "Guardar" manda
 * dos peticiones y, en el caso de "Crear cuenta", la segunda responde 409 por
 * correo duplicado: el usuario ve un error justo después de que su cuenta se
 * creara bien.
 *
 * `cta` es el acento cálido: la ÚNICA llamada a la acción de una pantalla. El
 * resto de acciones van con la marca (`primario`), para que el coral no pierda
 * fuerza repitiéndose.
 *
 * @param {React.ButtonHTMLAttributes<HTMLButtonElement> & {
 *   variante?: 'primario' | 'cta' | 'secundario' | 'peligro',
 *   cargando?: boolean,
 *   children: React.ReactNode,
 * }} props
 */
export function Boton({
  variante = 'primario',
  cargando = false,
  className = '',
  children,
  disabled,
  type = 'button',
  ...resto
}) {
  const variantes = {
    primario: 'bg-brand-600 text-white hover:bg-brand-700 disabled:hover:bg-brand-600',
    // Sobre el coral va texto oscuro, no blanco: el naranja es demasiado claro
    // para sostener blanco con contraste suficiente.
    cta: 'bg-linear-to-br from-coral-500 to-coral-600 font-semibold text-coral-950 hover:from-coral-400 hover:to-coral-500 disabled:hover:from-coral-500 disabled:hover:to-coral-600',
    secundario:
      'bg-superficie text-ink-700 ring-1 ring-inset ring-ink-300 hover:bg-ink-50 hover:text-brand-700 disabled:hover:bg-superficie',
    peligro: 'bg-peligro-600 text-white hover:bg-peligro-700 disabled:hover:bg-peligro-600',
  };

  return (
    <button
      // `button` por defecto, no `submit`: un botón dentro de un formulario que
      // no quiere enviarlo no debe enviarlo.
      type={type}
      disabled={disabled || cargando}
      aria-busy={cargando || undefined}
      className={`inline-flex items-center justify-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium transition-all active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60 ${variantes[variante]} ${className}`}
      {...resto}
    >
      {cargando ? (
        <span
          className="size-4 animate-spin rounded-full border-2 border-current border-t-transparent"
          aria-hidden="true"
        />
      ) : null}
      {children}
    </button>
  );
}
